export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-200px.19a4f74a.jpg";